import { GetterTree } from "vuex";
import { RootState } from "../types";
import { MembersInt } from "./types";
export const getters: GetterTree<MembersInt, RootState> = {};
